import React, { useEffect, useState } from "react";
import "./AddExpenses.css";
import ButtonSpinner from "../../../../Components/Spinners/ButtonSpinner";
import AddExpensesViewModal from "./AddExpensesViewModal";
import { Autocomplete, Avatar, TextField } from "@mui/material";
import { StringAvatar } from "../../../../Helpers/StringAvatar";
import IsSchoolAdded from "../../../../Hooks/IsSchoolAdded";
import Select from "react-select";
const AddExpenses = () => {
  const {
    NewExpense,
    setNewExpense,
    AddNewExpense,
    ExpenseItemError,
    ExpenseDateError,
    ExpenseAmountError,
    ExpensePurchaseSourceError,
    IsUpdate,
    loader,
    ExpenseTypeError,
    AllTeachers,
    UserType,
    setUserType,
    UserId,
    setUserId,
    ExpenseUserTypeError,
    UserIdError,
  } = AddExpensesViewModal();

  let AutocompleteDefaultValueIndex = 0;
  if (IsUpdate) {
    AutocompleteDefaultValueIndex = AllTeachers.findIndex((teacher) => {
      return teacher.id === UserId;
    });
  }

  const [autoCompleteValue, setAutoCompleteValue] = useState(
    AllTeachers[AutocompleteDefaultValueIndex]
  );
  const SchoolAddedResp = IsSchoolAdded();

  return (
    <div className="page-wrapper add-expense">
      <div className="content container-fluid">
        {/* Page Header */}
        <div className="page-header">
          <div className="row align-items-center">
            <div className="col">
              <h3 className="page-title">
                {IsUpdate ? "Update Expense" : "Add Expenses"}
              </h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="expenses.html">Accounts</a>
                </li>
                <li className="breadcrumb-item active">
                  {IsUpdate ? "Update Expense" : "Add Expenses"}
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* /Page Header */}
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-12">
                      <h5 className="form-title">
                        <span>Expense Information</span>
                      </h5>
                      {!SchoolAddedResp && (
                        <div className="add-school-first-container">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            class="bi bi-exclamation-triangle-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                          </svg>
                          <p>Please add school first!</p>
                        </div>
                      )}
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="form-group local-forms">
                        <label>
                          Expense Type <span className="login-danger">*</span>
                        </label>

                        <Select
                          className={`
                                  select-expense-type
                                  ${
                                    ExpenseTypeError
                                      ? "select-expense-type-error"
                                      : ""
                                  }
                                 
                                  `}
                          onChange={(e) => {
                            setNewExpense({
                              ...NewExpense,
                              ExpenseType: e.value,
                            });
                          }}
                          disabled={loader || !SchoolAddedResp}
                          options={[
                            {
                              value: "rent",
                              label: "Select Expense type",
                              isDisabled: true,
                            },
                            { value: "rent", label: "Rent" },
                            { value: "utility", label: "Utility" },
                            { value: "salary", label: "Salary" },
                            { value: "others", label: "Others" },
                          ]}
                        />
                        {/* <ReactSelect
                          error={ExpenseTypeError === true ? true : false}
                          handleChange={(val) => {
                            setNewExpense({
                              ...NewExpense,
                              ExpenseType: val,
                            });
                          }}
                          defaultValue={NewExpense.ExpenseType}
                          options={[
                            {
                              value: "rent",
                              label: "Select Expense type",
                              isDisabled: true,
                            },
                            { value: "rent", label: "Rent" },
                            { value: "utility", label: "Utility" },
                            { value: "salary", label: "Salary" },
                            { value: "others", label: "Others" },
                          ]}
                        /> */}
                      </div>
                    </div>
                    {NewExpense?.ExpenseType === "salary" && (
                      <>
                        <div className="col-12 col-sm-4">
                          <div className="form-group local-forms">
                            <label>
                              User Role <span className="login-danger">*</span>
                            </label>
                            <select
                              className={`form-control ${
                                ExpenseUserTypeError && "error-message"
                              }`}
                              onChange={(e) => {
                                setUserType(e.target.value);
                              }}
                              value={UserType}
                              disabled={loader || !SchoolAddedResp}
                            >
                              <option disabled>Select User type</option>

                              <option value="teacher">Teacher</option>
                              <option value="accountant" disabled>
                                Accountant
                              </option>
                              <option value="other" disabled>
                                Others
                              </option>
                            </select>
                            <i className="fa-solid fa-caret-down expense-select-dropdown"></i>
                          </div>
                        </div>

                        <div className="col-12 col-sm-4">
                          <Autocomplete
                            id="tags-outlined"
                            options={AllTeachers}
                            getOptionLabel={(option) =>
                              option?.FirstName + " " + option?.LastName
                            }
                            onChange={(event, value, reason, details) => {
                              setUserId(details.option.uid);
                            }}
                            value={autoCompleteValue}
                            renderOption={(props, option) => {
                              return (
                                <li {...props} key={option.id}>
                                  <Avatar
                                    {...StringAvatar(
                                      option?.FirstName + option?.LastName
                                    )}
                                  />
                                  <span className="name-reg-container">
                                    <span className="user-name">
                                      {option?.FirstName +
                                        " " +
                                        option?.LastName}
                                    </span>
                                    <span className="reg-no">
                                      Reg No:
                                      {
                                        option?.AdditionalDetails
                                          ?.StudentRegistrationNo
                                      }
                                    </span>
                                  </span>
                                </li>
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                error={UserIdError ? true : false}
                                {...params}
                                InputProps={{
                                  ...params.InputProps,
                                }}
                                InputLabelProps={{ shrink: true }}
                                label={
                                  UserType.charAt(0).toUpperCase() +
                                  UserType.slice(1)
                                }
                              />
                            )}
                          />
                        </div>
                      </>
                    )}
                    <div className="col-12 col-sm-4">
                      <div className="form-group local-forms">
                        <label>
                          Expense Name <span className="login-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            ExpenseItemError === true && "error-message"
                          }`}
                          onChange={(e) => {
                            setNewExpense({
                              ...NewExpense,
                              ExpenseItem: e.target.value,
                            });
                          }}
                          value={NewExpense?.ExpenseItem}
                          disabled={loader || !SchoolAddedResp}
                        />
                        {ExpenseItemError ? (
                          <span className="expense-tooltip">
                            <i className="fa-solid fa-info icon-after-submit"></i>
                            <span className="text-after-submit">
                              Expense item is required
                            </span>
                          </span>
                        ) : (
                          <span className="expense-tooltip">
                            <i className="fa-solid fa-info text-info"></i>
                            <span className="expense-tooltip-text">
                              Expense item
                            </span>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="form-group local-forms">
                        <label>
                          Date <span className="login-danger">*</span>
                        </label>
                        <input
                          type="date"
                          className={`form-control ${
                            ExpenseDateError === true && "error-message"
                          }`}
                          onChange={(e) => {
                            setNewExpense({
                              ...NewExpense,
                              Date: e.target.value,
                            });
                          }}
                          value={NewExpense?.Date}
                          disabled={loader || !SchoolAddedResp}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="form-group local-forms">
                        <label>
                          Expense Amount <span className="login-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control ${
                            ExpenseAmountError === true && "error-message"
                          }`}
                          onChange={(e) => {
                            setNewExpense({
                              ...NewExpense,
                              ExpenseAmount:
                                e.target.value < 0 ? 0 : e.target.value,
                            });
                          }}
                          value={NewExpense?.ExpenseAmount}
                          disabled={loader || !SchoolAddedResp}
                        />
                        {ExpenseAmountError ? (
                          <span className="expense-tooltip">
                            <i className="fa-solid fa-info icon-after-submit"></i>
                            <span className="text-after-submit">
                              Expense Amount is required
                            </span>
                          </span>
                        ) : (
                          <span className="expense-tooltip">
                            <i className="fa-solid fa-info text-info"></i>
                            <span className="expense-tooltip-text">
                              Expense Amount
                            </span>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="form-group local-forms">
                        <label>
                          Expense Source
                          <span className="login-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            ExpensePurchaseSourceError === true &&
                            "error-message"
                          }`}
                          onChange={(e) => {
                            setNewExpense({
                              ...NewExpense,
                              ExpensePurchaseSource: e.target.value,
                            });
                          }}
                          value={NewExpense?.ExpensePurchaseSource}
                          disabled={loader || !SchoolAddedResp}
                        />
                        {ExpensePurchaseSourceError ? (
                          <span className="expense-tooltip">
                            <i className="fa-solid fa-info icon-after-submit"></i>
                            <span className="text-after-submit">
                              Expense Purchase Source is required
                            </span>
                          </span>
                        ) : (
                          <span className="expense-tooltip">
                            <i className="fa-solid fa-info text-info"></i>
                            <span className="expense-tooltip-text">
                              Expense Purchase Source
                            </span>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="student-submit">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          onClick={(e) => {
                            e.preventDefault();
                            AddNewExpense();
                          }}
                          disabled={loader || !SchoolAddedResp}
                        >
                          {loader && <ButtonSpinner />}
                          {IsUpdate ? "Update" : "Submit"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddExpenses;
